/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type SbSharedFollowSearchProvider_itemSearch$ref = any;
export type SbSharedFollowSearchProvider_itemSearch = {
    readonly canFollowSearch: boolean | null;
    readonly displayUriRef: string | null;
    readonly meta: {
        readonly header: string | null;
    } | null;
    readonly " $refType": SbSharedFollowSearchProvider_itemSearch$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "SbSharedFollowSearchProvider_itemSearch",
    "type": "ItemSearchQueryConnection",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "canFollowSearch",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "displayUriRef",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "LinkedField",
            "alias": null,
            "name": "meta",
            "storageKey": null,
            "args": null,
            "concreteType": "MetaData",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "header",
                    "args": null,
                    "storageKey": null
                }
            ]
        }
    ]
} as any);
(node as any).hash = '2c09116ec2afce1f52a5b315c8514ab0';
export default node;
